import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { pdfColors } from '../theme';

interface Props {
  text: string;
  /** Smaller for a half sheet (A5). */
  compact?: boolean;
}

const styles = StyleSheet.create({
  wrap: {
    position: 'absolute',
    top: 300,
    left: 0,
    right: 0,
    alignItems: 'center',
    opacity: 0.08,
    zIndex: -1,
  },
  text: {
    fontSize: 72,
    fontWeight: 700,
    color: pdfColors.textPrimary,
    letterSpacing: 10,
    transform: 'rotate(-24deg)',
  },
});

/** A diagonal watermark overlay — fixed so it stamps every page. Use for
 *  DUPLICATE / DRAFT / SPECIMEN overlays. */
const Watermark: React.FC<Props> = ({ text, compact }) => (
  <View style={compact ? [styles.wrap, { top: 250 }] : styles.wrap} fixed>
    <Text style={compact ? [styles.text, { fontSize: 46, letterSpacing: 6 }] : styles.text}>{text}</Text>
  </View>
);

export default Watermark;
